import {isToday} from "@/helpers/functions_asi";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";

export default class DailyPlanningData {

	public date!: Date;
	public entries!: PlanningEntryListEntry[];
	public isToday!: boolean;

	constructor(date: Date, entries: PlanningEntryListEntry[] = []) {
		this.date = date;
		this.entries = entries;

		this.isToday = isToday(this.date);
	}

	public addEntry(entry: PlanningEntryListEntry): void {
		this.entries.push(entry);
	}

	public clearEntries(): void {
		this.entries = [];
	}

}
